// components/SwiperCarousel.tsx
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./CarouselOutils.css"; // CSS personnalisé
import { useNavigate } from "react-router-dom";

type SwiperCarouselProps = {
  images: string[];
}; 

export const SwiperCarousel = ({ images }: SwiperCarouselProps) => {
  const navigate = useNavigate();
  return (
    <div className="carousel-container" >
      <h3>Outils de rétablissement</h3>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={3}
        loop={true}
        autoplay={{ delay: 2000 }}
        pagination={{ clickable: true }}
        className="carousel"
      >
        {images.map((src, index) => (
          <SwiperSlide key={index}>
            <div className="carousel-image-container" onClick={() => console.log("fff")}>
              <img
                onClick={() => navigate("/outils")}
                src={src}
                alt={`Slide ${index}`}
                className="carousel-image"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
